export const LAYOUT_CARD = 'card';
export const LAYOUT_LINE = 'line';

export const REL_ITEM_TYPE_MODEL_BENEFIT_GROUP_REL = 'MODEL_BENEFIT_GROUP_REL';
export const REL_ITEM_TYPE_MODEL = 'MODEL';
